import { EntityListAction } from "projects/sepidz-web-framework/src/lib/models";

export class HrmLoanEdit extends EntityListAction {
  public HrmLoanToPersonnelId: number;
  public EditPercent: number;
  public EditAmount: number;
  public EditYear: number;
  public EditMonth: number;
  public EffectYear: number;
  public EffectMonth: number;
  public PeriodMonth: number;
  public EditDescription: string;
  public GrpLoanToPersId?: number;
}
